import { Link } from 'react-router-dom';
import s from './NotFound.module.scss';
// Если есть изображение для 404, можно импортировать:
// import notFoundImage from '../../assets/images/404.svg';

const NotFound = () => {
  return (
    <div className={s.notFound}>
      <div className={s.content}>
        {/* Если есть изображение:
        <img 
          src={notFoundImage} 
          alt="Страница не найдена" 
          className={styles.image}
        /> */}
        
        <div className={s.number}>404</div>
        
        <h1 className={s.title}>Страница не найдена</h1>
        
        <p className={s.message}>
          К сожалению, запрашиваемая страница не существует или была перемещена.
        </p>
        
        <div className={s.actions}>
          <Link to="/" className={s.button}>
            ← Вернуться на главную
          </Link>
          
          <Link to="/contacts" className={s.buttonSecondary}>
            Связаться с нами
          </Link>
        </div>
        
        <div className={s.tips}>
          <p>Что можно сделать:</p>
          <ul>
            <li>Проверьте правильность URL-адреса</li>
            <li>Вернитесь на предыдущую страницу</li>
            <li>Или перейдите в один из разделов сайта:</li>
          </ul>
          
          <div className={s.links}>
            <Link to="/services">Услуги</Link>
            <Link to="/about">О компании</Link>
            <Link to="/cases">Кейсы</Link>
            <Link to="/formats">Форматы работы</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;